import { applyMiddleware, createStore } from 'redux';
import layout from '../reducers/reducers.js';
import thunk from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import localforage from 'localforage';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { composeWithDevTools } from 'redux-devtools-extension';
import { connect, Provider } from 'react-redux';
export { Provider, connect, createStore, applyMiddleware, thunk, persistReducer, persistStore };
export default (function (pennywise, persist, key) {
  if (persist === void 0) {
    persist = true;
  }
  var middleware = applyMiddleware(thunk);
  if (process.env.NODE_ENV === 'development') {
    middleware = composeWithDevTools(applyMiddleware(thunk));
  }
  if (pennywise || !persist || !key) {
    var store = createStore(layout, middleware);
    return {
      store: store
    };
  } else {
    var persistConfig = {
      key: 'root',
      storage: localforage,
      blacklist: ['features', 'paymentModel', 'changeLanguageFunction', 'loading', 'banksToAdd', 'paymentInfo', 'billMatrix', 'loginPressed'],
      transforms: [encryptTransform({
        secretKey: key,
        onError: function (error) {
          throw new Error(error);
        }
      })]
    };
    var store = createStore(persistReducer(persistConfig, layout), {}, middleware);
    var persistor = persistStore(store);
    return {
      store: store,
      persistor: persistor
    };
  }
});